import type { CentralChatContextType, ChatHubAction } from './types';

export interface CentralChatNavigationParams {
  contextType?: CentralChatContextType;
  route?: string;
  prompt?: string;
  contentId?: string | null;
  templateId?: string | null;
  sectionId?: string | null;
  selectedText?: string | null;
  inputs?: Record<string, string | number | boolean | null | undefined>;
}

export function buildCentralChatHref(params: CentralChatNavigationParams = {}): string {
  const search = new URLSearchParams();

  append(search, 'context_type', params.contextType);
  append(search, 'route', params.route);
  append(search, 'prompt', params.prompt);
  append(search, 'content_id', params.contentId);
  append(search, 'template_id', params.templateId);
  append(search, 'section_id', params.sectionId);
  append(search, 'selected_text', params.selectedText);

  for (const [key, value] of Object.entries(params.inputs ?? {})) {
    append(search, `input_${key}`, value);
  }

  const query = search.toString();
  return query ? `/chat?${query}` : '/chat';
}

export function currentRoute(pathname: string, search: string): string {
  return `${pathname}${search}`;
}

export function offeredRoutePath(action: ChatHubAction): string | null {
  if (action.action_kind !== 'open_route') return null;
  const path = action.payload?.path;
  return typeof path === 'string' && path.startsWith('/') && !path.startsWith('//') ? path : null;
}

export function offeredActions(value: unknown): ChatHubAction[] | undefined {
  if (!Array.isArray(value) || value.length === 0) return undefined;
  const actions = value.filter((item): item is ChatHubAction => {
    if (!item || typeof item !== 'object') return false;
    const action = item as ChatHubAction;
    return (
      typeof action.id === 'string' &&
      typeof action.label === 'string' &&
      typeof action.action_kind === 'string'
    );
  });
  return actions.length ? actions : undefined;
}

function append(
  search: URLSearchParams,
  key: string,
  value: string | number | boolean | null | undefined,
) {
  if (value === null || value === undefined || value === '') return;
  search.set(key, String(value));
}
